
import { useCallback,useEffect,useState } from "react";
import { useWallet } from "use-wallet";
import { useAppGroupContract } from "./useContract";
import {SendFun,CallFun } from '../utils/contract';
import useWeb3 from './useWeb3';

function useLocked(address) {
  const { account } = useWallet();
  const web3 = useWeb3();
  const [lockedBalance, setLockedBalance] = useState({});
  const contract= useAppGroupContract(address);
  const { getBlockNumber } = useWallet();
  const blockNumber = getBlockNumber();
  
     // 用户提现
    // function withdraw(uint256 amount) public whenNotPaused {

      const withdraw = useCallback(
        async (amount , setLoading, isErc20,ErrFun) => {
          return await SendFun(
            contract,
            account,
            "withdraw",
            [ amount ],
            setLoading,
            isErc20?0:amount,
            ErrFun
            );
        },
        [account, contract]
      );
      /*
      uint256 amount,
      uint64 appid,
      uint64 apptypeid,
      uint64 businesstype,// 免费 收费 授权
      uint64 merchantid,
      uint64 profitrate,
      string memory name,
      string memory desc,
      uint256 minPledge,
      address owneraddr,
      string memory ext
      */
  const updateApps = useCallback(
    async (amount,appid,apptypeid,businesstype,merchantid,profitrate,name,funs,desc,minPledge,owneraddr,ext , setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "updateApps",
        [ amount,appid,apptypeid,businesstype,merchantid,profitrate,name,funs,desc,minPledge,owneraddr,ext ],
        setLoading,
        isErc20 ? null : amount
      );
    },
    [account, contract]
  );

  const updateAppVersion = useCallback(
    async ( versionid,appid,version,softtype,updatetag,docsurl,ext , setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "updateAppVersion",
        [  versionid,appid,version,softtype,updatetag,docsurl,ext  ],
        setLoading
      );
    },
    [account, contract]
  );


  const getAppsList = useCallback(
    async ( setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppsList",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );
  const getAppInfo = useCallback(
    async ( setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppInfo",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );

  

  const getAppTypeList = useCallback(
    async ( setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppTypeList",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );

  const getMerchantList = useCallback(
    async ( setLoading) => {
      return await CallFun(
        contract,
        account,
        "getMerchantList",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );

  const getAppVersionList = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppVersionList",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const getAppVersion = useCallback(
    async (appid,versionid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppVersion",
        [ appid,versionid ],
        setLoading
      );
    },
    [account, contract]
  );

  const hasApp = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "hasApp",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const getPledge = useCallback(
    async (setLoading) => {
      return await CallFun(
        contract,
        account,
        "getPledge",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );

  const setPledge = useCallback(
    async (pledge, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setPledge",
        [  pledge],
        setLoading
      );
    },
    [account, contract]
  );

  const isApp = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "isApp",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const getAppsExt = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppsExt",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const getAppTypeExt = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppTypeExt",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const getAppsMinPledge = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppsMinPledge",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const setAppsExt = useCallback(
    async (appid,ext, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setAppsExt",
        [  appid,ext],
        setLoading
      );
    },
    [account, contract]
  );

  const setAppTypeExt = useCallback(
    async (apptypeid,ext, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setAppTypeExt",
        [  apptypeid,ext],
        setLoading
      );
    },
    [account, contract]
  );

  const setAppStatus = useCallback(
    async (appid,status, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setAppStatus",
        [  appid,status],
        setLoading
      );
    },
    [account, contract]
  );

  const setAppsMintPrice = useCallback(
    async (appid,mintPrice, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setAppsMintPrice",
        [  appid,mintPrice],
        setLoading
      );
    },
    [account, contract]
  );

  const getAppsMintPrice = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAppsMintPrice",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const setDefMintPrice = useCallback(
    async (defMintPrice, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setDefMintPrice",
        [  defMintPrice],
        setLoading
      );
    },
    [account, contract]
  );

  const getdefMintPrice = useCallback(
    async (appid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getdefMintPrice",
        [ appid ],
        setLoading
      );
    },
    [account, contract]
  );

  const getToken = useCallback(
    async ( setLoading) => {
      return await CallFun(
        contract,
        account,
        "getToken",
        [  ],
        setLoading
      );
    },
    [account, contract]
  );
  const setToken = useCallback(
    async (newtoken, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setToken",
        [  newtoken],
        setLoading
      );
    },
    [account, contract]
  );


  return {
    AppGroupContract:contract,
    updateAppVersion,
    getAppTypeList,
    getMerchantList,
    getAppVersion,
    getAppVersionList,
   
    setDefMintPrice,
    getdefMintPrice,
    setAppsMintPrice,
    getAppsMintPrice,
    getAppsMinPledge,
    setAppStatus,
    getAppInfo,
    hasApp,
    isApp,
    getPledge,
    setPledge,
    setAppTypeExt,
    getAppTypeExt,
    getAppsExt,
    setAppsExt,

    withdraw,
    getAppsList,
    updateApps,
    setToken,
    getToken,

  };
}

export default useLocked;

